import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-hero">
        <img 
          src="https://i.pinimg.com/736x/74/5e/b4/745eb4641a75bbfaa0ac41446e135c1d.jpg" 
          alt="Privacy Policy Banner"
          className="privacy-image"
        />
        <h1>Privacy Policy</h1>
      </div>

      <div className="privacy-content">
        <p>
          <strong>GhoomoIndia</strong> respects your privacy and recognizes the need to protect 
          the personally identifiable information (any information by which you can be identified, 
          such as name, address, and telephone number) you share with us. We would like to assure you 
          that we follow appropriate standards when it comes to protecting your privacy on our websites.
        </p>

        <p>
          Some of our web pages use “cookies” so that we can better serve you with customized information 
          when you return to our site. Cookies are identifiers which a website can send to your browser 
          to keep on your computer to facilitate your next visit. You can set your browser to notify you 
          when you are sent a cookie, giving you the option to decide whether or not to accept it. 
          The information we collect and analyze is used to improve our service to you.
        </p>

        <p>
          There are times when we may collect personal information from you such as name, physical 
          address, or telephone number. It is our intent to inform you before we do that and to tell you 
          what we intend to do with the information. Generally, you will have the option not to provide 
          the information. If you choose not to provide the information, you can still visit our website 
          but you may be unable to access certain options, offers, and services.
        </p>

        <p>
          <strong>GhoomoIndia</strong> will not sell, trade, or disclose to third parties any information 
          derived from the registration for, or use of, any online service (including names and addresses) 
          without the consent of the user or customer (except as required by law or in the case of imminent 
          physical harm). Ghoomo India may allow suppliers to access the information for purposes of confirming 
          your registration and providing you with benefits you are entitled to.
        </p>

        <p>
          We have implemented technology and security features to safeguard the privacy of your 
          personally identifiable information from unauthorized access or improper use. 
          <strong> GhoomoIndia</strong> will continue to enhance our security procedures as new 
          technology becomes available.
        </p>

        <p>
          If our privacy policy changes in the future, it will be posted here with a new effective date. 
          You should access our privacy policy regularly to ensure you understand our current practices. 
          <br />For any inquiries, please email us at <strong>ghoomoindiaa@gmail.com</strong>.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
